import { type FC, type PropsWithChildren } from 'react';

import { Loading } from './Loading';

export type LoadingOverlayProps = PropsWithChildren<{ loading: boolean }>;

export const LoadingOverlay: FC<LoadingOverlayProps> = ({
  loading,
  children,
}) => {
  return (
    <div className="relative size-full">
      {children}
      {loading ? (
        <div className="absolute inset-0">
          <Loading />
        </div>
      ) : null}
    </div>
  );
};
